import React from 'react'
import { graphql, useStaticQuery} from 'gatsby'
import PostCover from './PostCoverComponent'
import './PostCover.scss'

const queryWrapper = ({ postNode, coverHeight, coverClassName }) => {
  const data = useStaticQuery(graphql`
    query CoverQuery {
      allFile(
        filter: { relativeDirectory: { regex: "images/(posts|videos)/" } }
      ) {
        edges {
          node {
            id
            absolutePath
            childImageSharp {
              gatsbyImageData(
                width: 1240
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  `);
  return (
    <PostCover
      fileEdges={data.allFile.edges}
      postNode={postNode}
      coverHeight={coverHeight}
      coverClassName={coverClassName}
    />
  )
}

export default queryWrapper;
